import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {ComuneCittadinoSummaryDTO} from '../../core/api/generated';

/**
 * Holder del Comune cittadino attualmente attivo nella sessione.
 * Lo slug effettivo è persistito in LocalStorageService.setSlugComune$;
 * questo service espone solo nome+logo per il banner della home e i consumer
 * che mostrano informazioni del Comune corrente.
 */
@Injectable({providedIn: 'root'})
export class GlobalManagerComuneService {
  private readonly _comuneSelezionato$ = new BehaviorSubject<ComuneCittadinoSummaryDTO | null>(null);
  readonly comuneSelezionato$: Observable<ComuneCittadinoSummaryDTO | null> = this._comuneSelezionato$.asObservable();

  /**
   * `true` se il comune attivo offre più di una tipologia di bando aperta (es. Mensa +
   * Buoni libro). Governa gli auto-skip: con più tipologie il cittadino deve poter vedere
   * e cambiare la scelta, quindi la pagina Bandi non va saltata (vedi `bandiTargetPath`).
   *
   * Vive qui, accanto al comune, perché è una proprietà DEL COMUNE attivo e non del servizio:
   * `bandiTargetPath` è una funzione pura sincrona chiamata da 4 punti (menu, CTA Home, blocco
   * studenti mensa, auto-skip Home) e renderla asincrona li romperebbe tutti. Lo popola chi
   * carica il catalogo (`CatalogoServiziCittadinoService.getCatalogoComune$`): Home e Bandi.
   *
   * Default `false` = comportamento storico (auto-skip attivo): un comune non ancora
   * caricato non deve inibire lo scorciatoio.
   */
  private readonly _comuneMultiTipologia$ = new BehaviorSubject<boolean>(false);
  readonly comuneMultiTipologia$: Observable<boolean> = this._comuneMultiTipologia$.asObservable();

  get comuneSelezionato(): ComuneCittadinoSummaryDTO | null {
    return this._comuneSelezionato$.getValue();
  }

  get comuneMultiTipologia(): boolean {
    return this._comuneMultiTipologia$.getValue();
  }

  setComuneSelezionato(comune: ComuneCittadinoSummaryDTO | null): void {
    this._comuneSelezionato$.next(comune);
  }

  setComuneMultiTipologia(multi: boolean): void {
    this._comuneMultiTipologia$.next(multi);
  }

  reset(): void {
    this._comuneSelezionato$.next(null);
    // Il flag appartiene al comune: sopravvivergli farebbe decidere gli auto-skip del comune
    // nuovo col catalogo di quello vecchio.
    this._comuneMultiTipologia$.next(false);
  }
}
